export default __webpack_public_path__ + "static/media/estate.87a37486.png";